// extracted by mini-css-extract-plugin
module.exports = {"Overlay":"Overlay_Overlay__2O_N9"};